import * as React from 'react';

interface OwnProps {
	isAvailable: boolean;
	label: string;
	statusLabelClassname?: string;
	grey?: boolean;
}

type Props = OwnProps;

const StatusLabel: React.FC<Props> = (props) => {
	const { isAvailable, label, statusLabelClassname, grey } = props;

	let className = 'status-label__icon';
	className = isAvailable ? `${className} icon-dot` : `${className} icon-dot_outline`;
	if (grey) {
		className = `${className} status-label__icon--down`;
	} else {
		className = isAvailable ? `${className} status-label__icon--available` : `${className} status-label__icon--unavailable`;
	}

	return (
		<div className={'status-label' + (statusLabelClassname ?? '')}>
			<span className={className} />
			{label}
		</div>
	);
};

export default StatusLabel;
